import { WalletType } from "@domain/group/group";
import { FilterType } from "./wallet";

export interface WalletDraft {
	id: string;
	//walletType?: WalletType;
	shipperNumber: string;
	serviceCode: string;
	solde?: string;
	currency?: string;
	label?: string;
	value?: string;
	paymentUrl?: string;
	curreny?: string;
	period?: FilterType;
	amountIUC?: number;
	date?: string;
	mode?: string;
	type?: string;
	issuerNumber?: string;
	issuerPrimaryName?: string;
	issuerSecondaryName?: string;
	subscriptionMode?: string;
	userCurrency?: string;

	// disbursement
}

export interface DisbursementDraft {
	id?: string;
	userCurrency?: string;
	month?: string;
	cashable?: number;
	cashableIUC?: number;
	status?: string;
	unitPrice?: number;
	isBalanceWithdrawable?: boolean;
	transactionStatus?: string;
	serviceCode?: WalletType;
}

export enum DisbursementType {
	WITHDRAWABLE = "WITHDRAWABLE",
	NOT_WITHDRAWABLE = "NOT_WITHDRAWABLE",
	WITHDRAWN = "WITHDRAWN",
	PENDING_WITHDRAWAL = "PENDING_WITHDRAWAL",
}
